import React from 'react';
import * as NProgress from 'nprogress';

import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';

import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';

import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';

// import InputLabel from '@mui/material/InputLabel';
// import MenuItem from '@mui/material/MenuItem';
// import FormControl from '@mui/material/FormControl';
// import Select from '@mui/material/Select';

// import Checkbox from '@mui/material/Checkbox';
// import ListItemIcon from '@mui/material/ListItemIcon';
// import ListItemText from '@mui/material/ListItemText';

import notify from '../../lib/notify';

import { subscribeToWeeklyUpdateApiMethod, sendEditLinkApiMethod } from '../../lib/api';

type Props = {
  onClose: () => void;
  open: boolean;
};

type State = {
  disabled: boolean;
  value: number;
  email: string;
  selectedCategory: string;
  selectedStates: string[];
};

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
      style={{ height: '100%' }}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

class WeeklyUpdateModal extends React.Component<Props, State> {
  public state = {
    disabled: false,
    value: 0,
    email: '',
    selectedCategory: 'all-categories',
    selectedStates: ['all-states'],
  };

  public render() {
    // get data
    const { open } = this.props;
    const { value, disabled } = this.state;

    return (
      <Dialog
        onClose={this.handleClose}
        aria-labelledby="newsletter-modal-dialog-title"
        open={open}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle id="newsletter-modal-dialog-title" sx={{ background: '#dce7f1' }}>
          <h3 style={{ textAlign: 'center' }}>Weekly update</h3>
          <p style={{ textAlign: 'center' }}>
            One email every Friday evening with the latest biotech startup jobs.
          </p>
        </DialogTitle>

        <IconButton
          onClick={this.handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>

        <DialogContent sx={{ background: '#dce7f1' }}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Tabs
              value={value}
              onChange={this.handleTabChange}
              aria-label="simple-tabs"
              variant="fullWidth"
              centered
            >
              <Tab label="Get weekly email" {...a11yProps(0)} />
              <Tab label="Edit my preferences" {...a11yProps(1)} />
            </Tabs>
          </Box>
          <TabPanel value={value} index={0}>
            <p>Join thousands of biotech professionals getting new jobs every Friday.</p>
            <p />
            <Box
              component="form"
              autoComplete="off"
              onSubmit={this.onSubmitSubscribe}
              sx={{
                display: 'inline-flex',
                flexDirection: { xs: 'column', md: 'row' },
                alignItems: 'center',
                width: '100%',
              }}
            >
              <TextField
                autoComplete="off"
                required
                type="email"
                label="Email"
                value={this.state.email}
                onChange={(event) => {
                  this.setState({ email: event.target.value });
                }}
                sx={{ margin: '10px 5px', width: { xs: '100%', md: '360px' } }}
              />{' '}
              <p />
              <Button
                variant="contained"
                color="success"
                type="submit"
                sx={{ margin: '10px 5px', width: { xs: '100%', md: 'auto' } }}
                disabled={disabled}
              >
                Get weekly email
              </Button>
              <p />
              <br />
            </Box>
          </TabPanel>
          <TabPanel value={value} index={1}>
            <p>Enter your email to manage your weekly update.</p>
            <p />
            <Box
              component="form"
              autoComplete="off"
              onSubmit={this.onSubmitEdit}
              sx={{
                display: 'inline-flex',
                flexDirection: { xs: 'column', md: 'row' },
                alignItems: 'center',
                width: '100%',
              }}
            >
              <TextField
                autoComplete="off"
                required
                type="email"
                label="Email"
                value={this.state.email}
                onChange={(event) => {
                  this.setState({ email: event.target.value });
                }}
                sx={{ margin: '10px 5px', width: { xs: '100%', md: '360px' } }}
              />
              <p />
              <Button
                variant="contained"
                color="primary"
                type="submit"
                sx={{ margin: '10px 5px', width: { xs: '100%', md: 'auto' } }}
                disabled={disabled}
              >
                Edit my preferences
              </Button>
              <p />
              <br />
            </Box>
          </TabPanel>
        </DialogContent>
      </Dialog>
    );
  }

  private handleClose = () => {
    this.props.onClose();
  };

  private handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    event.preventDefault();
    this.setState({ value: newValue });
  };

  private onSubmitSubscribe = async (event) => {
    event.preventDefault();
    const { email } = this.state;

    if (!email) {
      notify('Please provide email address.');
    } else {
      if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email)) {
        notify('Invalid email address');
        return;
      }

      NProgress.start();
      this.setState({ disabled: true });

      try {
        const { error } = await subscribeToWeeklyUpdateApiMethod({
          email,
        });

        if (!error) {
          notify('We sent you a confirmation email, please click on the confirmation link.');
        } else {
          notify(error);
        }
      } catch (error) {
        notify(error);
      } finally {
        this.setState({ disabled: false });
        // this.props.onClose();
        NProgress.done();
      }
    }
  };

  private onSubmitEdit = async (event) => {
    event.preventDefault();
    const { email } = this.state;

    if (!email) {
      notify('Please provide email address.');
    } else {
      if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email)) {
        notify('Invalid email address.');
        return;
      }

      NProgress.start();
      this.setState({ disabled: true });

      try {
        const { error } = await sendEditLinkApiMethod({
          email,
        });

        if (!error) {
          notify('We sent you an email with a link to edit your preferences.');
        } else {
          notify(error);
        }
      } catch (error) {
        notify(error);
      } finally {
        this.setState({ disabled: false });
        NProgress.done();
      }
    }
  };

  // private handleChangeForStateSelector = (event) => {
  //   const value = event.target.value;

  //   const isAllIncludedLast =
  //     value.length > 0 &&
  //     (value[value.length - 1] === 'All states' || value[value.length - 1] === 'all-states');

  //   const isAllIncludedButNotLast =
  //     value.length > 0 &&
  //     value[value.length - 1] !== 'All states' &&
  //     (value.indexOf('All states') > -1 || value.indexOf('all-states') > -1);

  //   if (isAllIncludedLast) {
  //     this.setState({
  //       selectedStates: ['all-states'],
  //     });
  //   } else if (isAllIncludedButNotLast) {
  //     this.setState({
  //       selectedStates: value.filter((s) => s !== 'All states'),
  //     });
  //   } else {
  //     this.setState({
  //       selectedStates: value,
  //     });
  //   }
  //   };
  // };
}

export default WeeklyUpdateModal;
